import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-ar/htdocs/ar.puramas.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-ar/htdocs/ar.puramas.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-ar/htdocs/ar.puramas.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/puramas-ar/htdocs/ar.puramas.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/puramas-ar/htdocs/ar.puramas.co/node_modules/next/dist/client/image-component.js");
